import { Box, Button, Heading, HStack, Spacer, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import {
  TextInput,
  useBoolean,
  usePaginationSessionStorage,
  useTabStorage,
} from '@laxmimanogna/code-quick-components';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import CQContainer from '../../components/layout/CQContainer';
import AppColors from '../../constants/AppColors';
import { SearchIcon } from '../../constants/IconData';
import { FONT_FAMILY } from '../../constants/Theme';
import { withProvider } from '../../hoc/withProvider';
import AccountsProvider, {
  AccountContext,
} from '../../providers/AccountsProvider';
import Select from 'react-select';
import AddHealthSystemAccountForm from './forms/AddHealthSystemAccountForm';
import AccountsTable from './table/AccountsTable';
import NewAccountsTableV3 from './table/NewAccountsTableV3';
import { ACCOUNTS_PAGE_NAME, ACCOUNTS_TABLE_NAME } from './constants';
import { ACCOUNTS_FILTER_OPTIONS, ACCOUNTS_FILTER_OPTIONS_TO_ACCOUNT_QUERY_MAP } from '../../constants/constants';


const AllAccountsTab = [
  
  {
    title: 'All Charts',
    header: 'All Charts',
    component: NewAccountsTableV3,
  },
];

const DropdownComponent = ({
  options,
  setSelected,
  selected,
  placeholder = "Select Options",
  isDisabled=false,
  disabledText = "Dropdown disabled",
  isLoading=false,
  isClearable=true,
  isSearchable=true
}) => {
  const handleChange = (option) => {
    setSelected(option);
  }

  return (
    <div
    style={{
      flex:1,
    }}>
      <Select 
      options={options}
      onChange={handleChange}
      isClearable={isClearable}
      placeholder={placeholder}
      isDisabled={isDisabled}
      value={selected}
      isLoading={isLoading}
      isSearchable={isSearchable}
      /> 
    </div> 
  )
}


function AccountsContainerV2() {

  const tabStorage = useTabStorage();
  const {
    getPaginationSession
  } = usePaginationSessionStorage();
  const accountsContext = useContext(AccountContext);
  const [selectedTab, setSelectedTab] = useState(0);
  const [onSearchText, setSearchText] = useState(getPaginationSession(ACCOUNTS_PAGE_NAME, ACCOUNTS_TABLE_NAME)?.search || '');
  const { 
    getAccountsList, 
    accountFilters, 
    getArchivedAccountsList, 
    archivedAccountFilters,
    setAccountStatusFilter,
    handleApplyFilter,
    isLoadingAccountsList
   } = accountsContext;
  // const [searchItem, setSearchItem] = React.useState('');
  // const [archivedSearchItem, setArchivedSearchItem] = React.useState('');
  const [ordering, setOrdering] = React.useState('');

  const [accountFormVisible, afvState] = useBoolean(false);
  const [showArchived, saState] = useBoolean(false);

  const dropdownOptions = useMemo(
    () => ACCOUNTS_FILTER_OPTIONS.map(val => ({ value: val, label: val })),
    [ACCOUNTS_FILTER_OPTIONS]
  );

  const [selectedFilter, setSelectedFilter] = useState(() => ({
    value: ACCOUNTS_FILTER_OPTIONS[tabStorage.getTab() || 0],
    label: ACCOUNTS_FILTER_OPTIONS[tabStorage.getTab() || 0]
  }));

  function handleOpenAddAccount() {
    afvState.on();
  }

  const onSearchAction = () => {
    accountsContext.handleApplyFilter({
      ...accountsContext.accountFilters,
      search: onSearchText,
    });
  };


  const onFilterChange = e => {
    if (e) {
      setSearchText(e.target.value);
    } else {
      setSearchText('');
    }
  };

   useEffect(() => {
      if (!selectedFilter.value) {
        return;
      }

      tabStorage.setTab(ACCOUNTS_FILTER_OPTIONS.indexOf(selectedFilter.value))
    }, [selectedFilter]);


  return (
          <CQContainer>
            <HStack mb={5}>
              <Heading as="h5" fontSize="24px">
                Accounts
              </Heading>
              <Spacer />
              <Button
              variant="solid"
              style={{height:'50px'}}
              borderRadius={25}
              fontWeight={500}
              backgroundColor={AppColors.primary}
              width={'186px'}
              paddingInline={'80px'}
              onClick={handleOpenAddAccount}
              height={'40px'}
              color={'white'}
              outline={`2px`}
              _hover={{
                transition: 'all .1s ease',
                bgColor: AppColors.white,
                color: AppColors.primary,
                outline: `2px solid ${AppColors.primary}`,
              }}
            >
              + Add New Account
            </Button>
            </HStack>
            <Box bg="white" p={4} w="100%" style={{ borderRadius: '12px' }} marginLeft={0}>
              <Tabs
                fontFamily={FONT_FAMILY.baiJamurjee}
                onChange={setSelectedTab}
                index={selectedTab}
              >
                <TabList borderBottom={'1px solid'}>
                  <HStack w={'100%'} justifyContent={'space-between'}>
                    {/* filtersss */}
                    <Box width={"30%"}>
                      <DropdownComponent
                      options={dropdownOptions}
                      selected={selectedFilter}
                      setSelected={option => {
                        setSelectedFilter(option);
                        setAccountStatusFilter(ACCOUNTS_FILTER_OPTIONS_TO_ACCOUNT_QUERY_MAP[option.value]);
                        getAccountsList.loadPageByFilterParams(ACCOUNTS_PAGE_NAME, ACCOUNTS_TABLE_NAME, {deleted: ACCOUNTS_FILTER_OPTIONS_TO_ACCOUNT_QUERY_MAP[option.value]})
                      }}
                      placeholder=''
                      isClearable={false}
                      isSearchable={false}
                      isDisabled={isLoadingAccountsList}
                      isLoading={isLoadingAccountsList}
                      />
                    </Box>
       
      
                    <Box>
                      <TextInput
                      height={'50px'}
                      mb={'10px'}
                      verticalAlign={'center'}
                        borderRadius={'md'}
                        value={onSearchText}
                        onChange={e => onFilterChange(e)}
                        onKeyDown={e => {
                          if (e.keyCode === 13) {
                            onSearchAction();
                          }
                        }}
                        // mb="2"
                        rightIconProps={{ zIndex: 0 }}
                        placeholder="Search"
                        rightIcon={<SearchIcon style={{marginTop:'15px'}} onClick={onSearchAction} />}
                        isDisabled={isLoadingAccountsList}
                      />
                    </Box>
                  </HStack>
                </TabList>
      
                <TabPanels>
                  {AllAccountsTab.map((aa, index) => {
                    return (
                      <TabPanel p={0} key={`assigned-audit-panel-${index}`}>
                        <aa.component 
                        key={`my-charts-panel-${index}`} 
                        PAGE_NAME={ACCOUNTS_PAGE_NAME}
                        TABLE_NAME={ACCOUNTS_TABLE_NAME}
                        showArchived = {selectedFilter.value === "Archived"}
                        />
                      </TabPanel>
                    );
                  })}
                </TabPanels>
              </Tabs>
            </Box>

            {/* FORM MODAL */}
            <AddHealthSystemAccountForm
              isOpen={accountFormVisible}
              onClose={afvState.off}
            />
          </CQContainer>
        );
}

export default withProvider(AccountsProvider, AccountsContainerV2);
